export const TEAM_NAME_TO_ABBR = {
  "Arizona Cardinals": "ARI",
  "Atlanta Falcons": "ATL",
  "Baltimore Ravens": "BAL",
  "Buffalo Bills": "BUF",
  "Carolina Panthers": "CAR",
  "Chicago Bears": "CHI",
  "Cincinnati Bengals": "CIN",
  "Cleveland Browns": "CLE",
  "Dallas Cowboys": "DAL",
  "Denver Broncos": "DEN",
  "Detroit Lions": "DET",
  "Green Bay Packers": "GB",
  "Houston Texans": "HOU",
  "Indianapolis Colts": "IND",
  "Jacksonville Jaguars": "JAX",
  "Kansas City Chiefs": "KC",
  "Las Vegas Raiders": "LV",
  "Los Angeles Chargers": "LAC",
  "Los Angeles Rams": "LAR",
  "Miami Dolphins": "MIA",
  "Minnesota Vikings": "MIN",
  "New England Patriots": "NE",
  "New Orleans Saints": "NO",
  "New York Giants": "NYG",
  "New York Jets": "NYJ",
  "Philadelphia Eagles": "PHI",
  "Pittsburgh Steelers": "PIT",
  "San Francisco 49ers": "SF",
  "Seattle Seahawks": "SEA",
  "Tampa Bay Buccaneers": "TB",
  "Tennessee Titans": "TEN",
  "Washington Commanders": "WSH"
};

export function getTeamAbbr(fullName) {
  return TEAM_NAME_TO_ABBR[fullName] || null;
}

// ESPN's own numeric team ids -- stable identifiers ESPN has used for years,
// not generated by this app. `/api/v1/schedules` and `/api/v1/injuries` both
// take home_team_id/away_team_id and pass them straight through to ESPN
// (Schedule#fetch_team_schedule, Injuries), but nothing in `games` or the
// /api/v1/games payload stores an ESPN team id -- only team names/abbrs. Without
// this map, homeTeam.id/awayTeam.id were always undefined, so both endpoints
// silently returned empty results for every game, not just preseason ones.
export const TEAM_ABBR_TO_ESPN_ID = {
  ARI: 22,
  ATL: 1,
  BAL: 33,
  BUF: 2,
  CAR: 29,
  CHI: 3,
  CIN: 4,
  CLE: 5,
  DAL: 6,
  DEN: 7,
  DET: 8,
  GB: 9,
  HOU: 34,
  IND: 11,
  JAX: 30,
  KC: 12,
  LV: 13,
  LAC: 24,
  LAR: 14,
  MIA: 15,
  MIN: 16,
  NE: 17,
  NO: 18,
  NYG: 19,
  NYJ: 20,
  PHI: 21,
  PIT: 23,
  SF: 25,
  SEA: 26,
  TB: 27,
  TEN: 10,
  WSH: 28,
};

export function getEspnTeamId(abbr) {
  return TEAM_ABBR_TO_ESPN_ID[abbr] || null;
}
